import { render } from "./CommonCloudStorage.vue?vue&type=template&id=4a25af3e&scoped=true"
import script from "./CommonCloudStorage.vue?vue&type=script&lang=js"
export * from "./CommonCloudStorage.vue?vue&type=script&lang=js"

import "./CommonCloudStorage.vue?vue&type=style&index=0&id=4a25af3e&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/xsurflog_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a25af3e"]])

export default __exports__